import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "../../data/comparison";
import { AFFILIATE_URL } from "../../lib/constants";
import { trackCta } from "../../lib/tracking";

export const FAQ = () => (
  <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="faq-section">
    <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-3 text-center">Common questions</p>
    <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-[#0F172A] mb-10 text-center">
      Frequently Asked Questions
    </h2>
    <Accordion type="single" collapsible className="w-full">
      {FAQS.map((f, i) => (
        <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
          <AccordionTrigger className="text-left font-heading font-bold text-base text-[#0F172A] hover:no-underline">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-slate-600 text-base leading-relaxed">
            {f.a}
            {f.cta && (
              <>
                {" "}
                <a
                  href={AFFILIATE_URL}
                  target="_blank"
                  rel="nofollow sponsored noopener"
                  onClick={() => trackCta("faq-inline", AFFILIATE_URL)}
                  data-testid="cta-faq-elevenlabs"
                  className="text-[#5A31F4] font-bold hover:underline"
                >
                  Try ElevenLabs for free →
                </a>
              </>
            )}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
